import * as views from "../views";

export default [
  {
    path: "account/upgrade",
    name: "Pricing",
    component: views.PlanPricing
  }
];
